import packageInfo from '../../package.json';
export const environment = {
  appName: packageInfo.name,
  appVersion: packageInfo.version,
  production: true,
  apiBaseUrl: 'https://prod.montraelectric.com/montra/one-platform/',
  googleMapKey: 'AIzaSyB6YF0SO3hqCHfMH5xTkxwHzCI4mpz5jhM',
  googleAnalyticsId: 'G-D434YVS259',
  enjmkey: 'theoneportalmontraelectric',
  recaptcha: {
    siteKey: '6Lc26nUqAAAAAMTB6DOhs5MO6yU0C89bs546UpnA',
  },
  enableDevTools: false,
  enableCaptcha: true,
  microsoft: {
    clientId: '0e31f362-ebbd-4d30-83cf-3b899d306aa4',
    tenantId: '362c9ff5-0473-4260-9078-d5da29e659db',
    authority:
      'https://login.microsoftonline.com/362c9ff5-0473-4260-9078-d5da29e659db',
    redirectUri: 'https://myev.montraelectric.com/login/',
    daasUrl: 'https://daas.montraelectric.com/',
  },
  daasUrl: 'https://daas.montraelectric.com/',
  daasMfeEnabled: false,
  salesForceBaseURL: {
    truck: 'https://customer-power-6899.my.salesforce.com/',
    threeWheeler: 'https://montraelectric.my.salesforce.com/',
  },
  airaUrl: 'https://aira-myev.montraelectric.com/',
  disabledFeatures: [''],
  reactRemoteUrl: 'https://insights.montraelectric.com/remoteEntry.js',
  daasRemoteUrl: 'https://daas.montraelectric.com/remoteEntry.js',
};
